import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import { authenticationServices } from "./services/authenticationServices";
import { ConfigProvider } from "antd";
import Routes from "./routes";
import fa from "antd/lib/locale-provider/fa_IR";
import en from "antd/lib/locale-provider/en_US";
import { Spin } from "antd";

//Context
import Provider from "context/Provider"

import "./styles/styles.css";
// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

const PrivateRoute = ({ component: Component, ...props }) =>
  authenticationServices.isAuthenticate() ? (
    <Component {...props} />
  ) : (
    <Redirect to="/login" />
  );

const App = () => {
  return (
    <Provider>      
    <ConfigProvider locale={"fa"} direction={"rtl"}>
      <React.Suspense fallback={<Spin className="spin-custom" />}>
        <BrowserRouter>
          <Switch>
            <Route
              exact
              path="/login"
              name="Login Page"
              render={(props) => <Login {...props} />}
            />
            <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            />
            <Route
              exact
              path="/404"
              name="Page 404"
              render={(props) => <Page404 {...props} />}
            />
            <Route
              exact
              path="/500"
              name="Page 500"
              render={(props) => <Page500 {...props} />}
            />
            <PrivateRoute name="Home" component={Routes} />
          </Switch>
        </BrowserRouter>
      </React.Suspense>
    </ConfigProvider>
    </Provider>
  );
};

export default App;
